module.exports = __webpack_public_path__ + "img/ea.a4525b4f.svg";